import React from 'react';
import Icon from './Icon';

export default function JourneyTimeline({ steps = [] }) {
  return (
    <ol className="journey-timeline">
      {steps.map((step, i) => (
        <li key={step.n} className="journey-step">
          <div className="journey-marker">
            <div className="journey-icon-wrap">
              <Icon name={step.icon} size={20} />
            </div>
            {i < steps.length - 1 && <div className="journey-line" aria-hidden="true" />}
          </div>
          <div className="journey-body">
            <div className="journey-head">
              <span className="journey-num">{step.n}</span>
              <h3 className="journey-title">{step.title}</h3>
              <span className="journey-awareness">{step.awareness}</span>
            </div>
            <p className="journey-desc">{step.desc}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
